import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import LayoutFilter from '../../components/LayoutFilter';
import { ActionBar } from '../../components/nav/ActionBar';
import useGetActualityAggregationGroupTitle from '../hooks/useGetActualityAggregationGroupTitle';
import { actualitySelectedEvent } from '../store/actuality.hq.state';
import {
  actualityAggregatedStatsSelectedGroups,
  actualityAggregatedStatsSelectedSubGroup,
} from '../store/actuality.kpi.state';

const ActualityAggregatedStatsFilters: React.FC = () => {
  const { t } = useTranslation('feed');
  const [selectedGroups, setSelectedGroups] = useRecoilState(
    actualityAggregatedStatsSelectedGroups,
  );
  const [selectedSubGroup, setSelectedSubgroup] = useRecoilState(
    actualityAggregatedStatsSelectedSubGroup,
  );
  const [selectedEvent, setSelectedEvent] = useRecoilState(
    actualitySelectedEvent,
  );

  const getGroupTitle = useGetActualityAggregationGroupTitle();

  return (
    <ActionBar transparent className={classNames('')} sticky>
      {_.map(selectedGroups, groupKey => {
        const title = getGroupTitle(groupKey);

        return (
          <LayoutFilter
            key={`selected-group-${title}`}
            type="selection"
            onRemoveClick={() =>
              setSelectedGroups(current =>
                _.filter(current, key => key !== groupKey),
              )
            }
            // className={classNames('flex-1')}
          >
            {title}
          </LayoutFilter>
        );
      })}

      {selectedSubGroup && (
        <LayoutFilter
          key={`selected-sub-group`}
          type="selection"
          onRemoveClick={() => setSelectedSubgroup(null)}
          // className={classNames('flex-1')}
        >
          {getGroupTitle(selectedSubGroup)}
        </LayoutFilter>
      )}

      {selectedEvent && (
        <LayoutFilter
          key={`selected-event`}
          type="selection"
          filterName={t`Event:`}
          onRemoveClick={() => setSelectedEvent(null)}
          className={classNames('max-w-[20ch] truncate ltr:ml-1 rtl:mr-1')}
        >
          {selectedEvent?.eventId}
        </LayoutFilter>
      )}
    </ActionBar>
  );
};

export default ActualityAggregatedStatsFilters;
